// Chakra imports
import { Portal, Box, Flex, Spinner, useDisclosure, Drawer } from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import { AuthContext } from 'contexts/AuthContext';
import React, { useState, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'routes.js';
import { DataContext } from 'contexts/DataContext';
import { DataContextProvider } from 'contexts/DataContext';
import { SIDEBAR_WIDTH } from 'config/layout';

// Custom Chakra theme
export default function Dashboard(props) {
  // Getting auth state from auth context
  const { isSignedIn, isAuthReady } = useContext(AuthContext);
  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };
  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  // Wait for Firebase to restore the session before deciding to redirect,
  // otherwise a refresh on /admin/<page> would always bounce to /auth.
  if (!isAuthReady) {
    return (
      <Flex minHeight="100vh" justify="center" align="center">
        <Spinner size="xl" />
      </Flex>
    );
  }
  if (!isSignedIn) return <Redirect to="/auth" />;

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar routes={routes} display="none" {...rest} />
        <DataContextProvider>
          <Box
            float="right"
            h="100vh"
            sx={{ '@supports (height: 100dvh)': { height: '100dvh' } }}
            display="flex"
            flexDirection="column"
            overflow="hidden"
            position="relative"
            w={{ base: '100%', xl: `calc( 100% - ${SIDEBAR_WIDTH - 10}px )` }}
            maxWidth={{ base: '100%', xl: `calc( 100% - ${SIDEBAR_WIDTH - 10}px )` }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'Horizon UI Dashboard PRO'}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                w="100%"
                flex="1"
                minH={0}
                display="flex"
                flexDirection="column"
                overflowY="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                pt="50px"
                pb={{ base: '12px', md: '16px' }}
              >
                <Switch>
                  {getRoutes(routes)}
                  <Redirect from="/" to="/admin/locations" />
                </Switch>
              </Box>
            ) : null}
            <Box flexShrink={0}>
              <Footer />
            </Box>
          </Box>
        </DataContextProvider>
      </SidebarContext.Provider>
    </Box>
  );
}
